import Image from '@/components/image';
import NextLink from '@/components/next-link';
import ArrowIcon from '@/components/ui/icons/arrow-icon';

const ExtraAttributes = ({ brand, t, productCategory }) => {
  const brandUrl = productCategory?.at(-1)?.url_key;

  return (
    <>
      {brand?.brandLabel && (
        <NextLink
          href={`/b/${brand?.url || brandUrl}`}
          className='flex max-h-18 min-h-18 items-center justify-between rounded-xl bg-gray-50 px-3 shadow-sm'
        >
          <div className='flex items-center gap-3'>
            <div className='flex size-12 items-center justify-center rounded-lg bg-white p-1.5 shadow-sm'>
              <Image
                src={`${process.env.NEXT_PUBLIC_IMG_BASEURL}/media/${brand?.brandLogo}`}
                className='size-full object-contain'
                alt={brand?.brandLabel}
                width={36}
                height={36}
              />
            </div>
            <div className='flex flex-col'>
              <h4 className='font-bold'>{brand?.brandLabel} </h4>
            </div>
          </div>
          <div className='flex max-w-[71px] min-w-[71px] items-center gap-2 rounded-lg bg-white px-3 py-1.5 shadow-sm'>
            <span className='text-xs font-medium text-blue-600'>
              {t('More')}
            </span>
            <ArrowIcon className='size-2.5 text-blue-600 ltr:-rotate-90 rtl:rotate-90' />
          </div>
        </NextLink>
      )}
    </>
  );
};

export default ExtraAttributes;
